// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"ca533a0a","128":"c2f09388"}[chunkId] + ".chunk.css";
};